import React, { useState, useEffect } from "react";
import { Card, Container, Col, Row, CardBody, NavLink } from "shards-react";
import { NavLink as RouteNavLink } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import moment from "moment";
import { useUsersData } from "../../providers/UsersDataProvider";
import guardianImage from "../../assets/dashboard/guardian.png";

const ReminderList = () => {
  const { loading, Users } = useUsersData();
  const [filteredUsers, setFilteredUsers] = useState(
    Users.filter(user => user.SessionDoneDaysAgo >= 2)
  );
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    if (filterText.length > 0) {
      setFilteredUsers(
        Users.filter(user => user.SessionDoneDaysAgo >= 2).filter(obj =>
          JSON.stringify(obj)
            .toLowerCase()
            .includes(filterText.toLowerCase())
        )
      );
    } else {
      setFilteredUsers(Users.filter(user => user.SessionDoneDaysAgo >= 2));
    }
  }, [Users, filterText]);

  const columns = [
    {
      dataField: "FirstName",
      text: "Full Name",
      sort: true,
      classes: "guardianParentClass",
      formatter: (cell, row) => {
        return (
          <NavLink
            style={{
              color: "inherit",
              fontSize: "inherit",
              fontWeight: 500,
              padding: 0,
              wordWrap: "break-word"
            }}
            tag={props => <RouteNavLink target={"_blank"} {...props} />}
            to={`/student-details/${row.uid}`}
          >
            {`${row.FirstName}`}
            {row.UserType && row.UserType === "Guardian" && (
              <img
                className="guardianIcon"
                alt="guardianIcon"
                src={guardianImage}
              />
            )}
          </NavLink>
        );
      }
    },
    {
      dataField: "FirstSessionDoneOn",
      text: "First T.D",
      sort: true,
      formatter: (cell, row) => {
        return (
          <>
            {cell
              ? moment(cell.toDate().toDateString()).format("MMM Do YY")
              : "-"}
          </>
        );
      }
    },
    {
      dataField: "LastSessionDoneAt",
      text: "Latest T.D",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span
            style={{
              color: checkDateForColorView(
                row.LastSessionDoneAt &&
                  row.LastSessionDoneAt.toDate().toDateString()
              )
            }}
          >
            {row.LastSessionDoneAt
              ? `${moment(row.LastSessionDoneAt.toDate().toDateString()).format(
                  "MMM Do YY"
                )}`
              : "-"
            // moment(
            //   row.LastSessionDoneAt.toDate().toString()
            // ).fromNow()
            }
          </span>
        );
      }
    },
    {
      dataField: "nextTestDate",
      text: "Next test",
      sort: true,
      formatter: (cell, row) => {
        return <>{cell ? moment(cell).format("MMM Do YY") : "-"}</>;
      }
    },
    {
      dataField: "CalibScore",
      sort: true,
      text: "Cal Score",
      formatter: (cell, row) => {
        return (
          <>
            {cell ? (
              <>
                <span>{cell}</span>
                {row.sign === "up" ? (
                  <i className="material-icons" style={{ cursor: "pointer" }}>
                    arrow_upward
                  </i>
                ) : row.sign === "down" ? (
                  <i className="material-icons" style={{ cursor: "pointer" }}>
                    arrow_downward
                  </i>
                ) : (
                  <i className="material-icons" style={{ cursor: "pointer" }}>
                    horizontal_rule
                  </i>
                )}
              </>
            ) : (
              "-"
            )}
          </>
        );
      }
    },
    {
      dataField: "StandardDeviation",
      text: "Training SD",
      sort: true,
      formatter: (cell, row) => {
        return <>{cell ? cell + "%" : "-"}</>;
      }
    },
    {
      dataField: "CalibrationStandardDeviation",
      text: "Cal SD",
      sort: true,
      formatter: (cell, row) => {
        return <>{cell ? cell + "%" : "-"}</>;
      }
    }
  ];

  // const getDaysAgo = (date) => {
  //   let currentDate = moment.now();
  //   let dateInDB = moment(date);
  //   let result = dateInDB.diff(currentDate, 'days');
  //   if (result < 0) {
  //     return `${-result} days ago`
  //   } else {
  //     return `${result} days ago`
  //   }
  // }

  const pagination = paginationFactory({
    sizePerPage: 50,
    hideSizePerPage: true
  });

  const checkDateForColorView = date => {
    if (date) {
      let currentDate = moment();
      let checkingDate = moment(date);
      let result = currentDate.diff(checkingDate, "days");
      if (result >= 7) {
        return "red";
      } else if (result <= 6 && result >= 3) {
        return "purple";
      } else if (result >= 1 && result <= 2) {
        return "orange";
      } else {
        return "green";
      }
    } else {
      return "black";
    }
  };

  const searchBar = () => {
    return (
      <input
        className="form-control"
        type="text"
        placeholder="Search in table"
        value={filterText}
        onChange={e => {
          // props.onSearch(e.target.value);
          setFilterText(e.target.value);
        }}
      />
    );
  };

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      {loading ? (
        <div className="wrapper">
          <div className="spinner">
            <div className="spinner-1"></div>
            <div className="spinner-2"></div>
            <div className="spinner-3"></div>
          </div>
        </div>
      ) : (
        <Row className="page-header py-4">
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-4 pb-3">
                <ToolkitProvider
                  keyField="uid"
                  data={filteredUsers}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {props => (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "15px 0px"
                        }}
                      >
                        <h6 className="m-0 font-weight-bold">
                          Reminder Students List
                        </h6>
                        <div className="w-60">{searchBar()}</div>
                      </div>
                      <BootstrapTable
                        pagination={pagination}
                        {...props.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                {/* <BootstrapTable keyField='uid' data={Users} columns={columns} pagination={pagination} rowEvents={rowEvents} bootstrap4 /> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default ReminderList;
